export const logPlayerStoreAction = (fnName: string, fnArgs: unknown) => {
  if (fnName === "syncProgress") return;

  const playerLogger = console.player?.log;
  const log = typeof playerLogger === "function" ? playerLogger : console.log;

  log(`[Action] ${fnName}`, fnArgs);
};
